import { isSyrasoftUser } from 'Commons/helpers/utils/Utils';
import { memo } from 'react';

const SyrasoftUserAccessible = ({ children }) => (isSyrasoftUser() ? <>{children}</> : null);

SyrasoftUserAccessible.propTypes = { children: PropTypes.node };

export default memo(SyrasoftUserAccessible);
